import * as React from "react";

import { VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import { styled, Box } from "@mui/material";

import constants from "../../constants";

const PasswordLabel = ({ showPassword, setLoginCardState }) => {
  const passwordLabelIconProps = {
    sx: {
      paddingLeft: (theme) => theme.spacing(1),
      cursor: "pointer",
    },
    fontSize: "small",
  };

  const handleShowPassword = () => {
    setLoginCardState({ showPassword: !showPassword });
  };

  return (
    <StyledBox>
      <span key="passwordLabel2">{constants.login.form.password.label}</span>
      {showPassword ? (
        <VisibilityOffOutlined
          key="passwordLabel4"
          onClick={handleShowPassword}
          {...passwordLabelIconProps}
        />
      ) : (
        <VisibilityOutlined
          key="passwordLabel3"
          onClick={handleShowPassword}
          {...passwordLabelIconProps}
        />
      )}
    </StyledBox>
  );
};

const StyledBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

export default PasswordLabel;
